<div class="main flex flex-column p-2">
  <div class="product-img">
    <img [src]="item.img" alt="Product Image" class="drag-preview-image mt-2" />
  </div>
  <div class="product-details">
    <span>{{item.name}}</span>
    <span>Sku: {{item.sku}}</span>
  </div>
</div>
